var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoleto = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134 100",
    style: {
      enableBackground: "new 0 0 134 100"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M8.1,100h117.8c4.5,0,8.1-3.6,8.1-8V68.3v-35v-9.9V8.1c0-4.4-3.6-8-8.1-8H76.8H52.4H8.1C3.6,0,0,3.6,0,8.1 v6.1v19.2v35v23.7C0,96.4,3.6,100,8.1,100z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.7,
    width: 3.4,
    height: 108.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: -0.7,
    width: 3.4,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: -0.7,
    width: 5.1,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: -0.7,
    width: 3.4,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: -0.7,
    width: 3.4,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9,
    y: -0.7,
    width: 1.7,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: -0.7,
    width: 1.7,
    height: 108.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: -0.7,
    width: 1.7,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: -0.7,
    width: 3.4,
    height: 96.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.3,
    y: -0.7,
    width: 1.7,
    height: 96.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: -0.7,
    width: 5.1,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.3,
    y: -0.7,
    width: 1.7,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.8,
    y: -0.7,
    width: 2.6,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: -0.7,
    width: 3.4,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.3,
    y: -0.7,
    width: 3.4,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: -0.7,
    width: 3.4,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.3,
    y: -0.7,
    width: 3.4,
    height: 108.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: -0.7,
    width: 1.7,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.4,
    y: -0.7,
    width: 1.7,
    height: 108.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.8,
    y: -0.7,
    width: 2.6,
    height: 108.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,88.5h7.4v1l-4.4,10.1h-1.5l4.6-9.9h-6.1V88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,89.5c0.3-0.3,0.7-0.6,1.1-0.8c0.5-0.2,1-0.3,1.7-0.3c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.2,1.2 c0.5,1,0.8,2.3,0.8,3.9c0,2.1-0.4,3.6-1.1,4.5c-0.6,0.7-1.5,1.1-2.7,1.1c-2.2,0-3.4-1.3-3.8-3.8c-0.1-0.5-0.1-1.1-0.1-1.8 c0-0.7,0-1.2,0.1-1.8c0.1-0.5,0.2-1,0.4-1.5C27,90.3,27.2,89.9,27.5,89.5z M32.3,91.1c-0.2-0.4-0.4-0.8-0.8-1 c-0.4-0.2-0.8-0.3-1.3-0.3c-0.5,0-0.9,0.1-1.2,0.2c-0.3,0.2-0.6,0.4-0.7,0.6c-0.2,0.3-0.3,0.6-0.4,1c-0.1,0.4-0.2,0.8-0.2,1.2 c0,0.4,0,0.8,0,1.3c0,0.5,0,0.9,0,1.3c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.2,0.7,0.4,1c0.2,0.3,0.4,0.5,0.7,0.6 c0.3,0.2,0.7,0.2,1.1,0.2c0.4,0,0.8-0.1,1.1-0.2c0.3-0.2,0.6-0.4,0.7-0.6c0.2-0.3,0.3-0.6,0.4-1c0.2-0.7,0.2-1.4,0.2-2.2 c0-0.8,0-1.5-0.1-1.9C32.6,92,32.4,91.5,32.3,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7,89c0.7-0.5,1.5-0.8,2.5-0.8s1.8,0.3,2.4,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,0.6-0.2,1.1-0.5,1.6 c-0.3,0.5-0.8,0.8-1.3,0.9v0.1c0.6,0.2,1.1,0.5,1.5,1c0.4,0.5,0.5,1.2,0.5,2c0,0.8-0.3,1.5-0.9,2.1c-0.6,0.6-1.5,0.9-2.6,0.9 c-1.1,0-2-0.3-2.7-0.8c-0.7-0.5-1.1-1.3-1.2-2.3h1.3c0.1,0.6,0.3,1.1,0.7,1.4c0.4,0.4,1,0.6,1.7,0.6s1.3-0.2,1.7-0.6 c0.4-0.4,0.6-0.9,0.6-1.5c0-0.8-0.3-1.4-0.8-1.7c-0.5-0.3-1.3-0.5-2.4-0.5H40v-1.2h0.4c1.9,0,2.9-0.6,2.9-1.8 c0-0.6-0.2-1-0.5-1.3c-0.4-0.3-0.9-0.5-1.5-0.5c-0.7,0-1.2,0.2-1.6,0.5c-0.4,0.3-0.6,0.7-0.7,1.2h-1.4C37.6,90.2,38,89.5,38.7,89 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6,88.5h6.7v1.2h-5.4v3.5c0.2-0.3,0.6-0.6,1-0.8c0.5-0.2,1-0.3,1.6-0.3c0.6,0,1.1,0.1,1.6,0.3 c0.5,0.2,0.9,0.5,1.1,0.9c0.5,0.7,0.8,1.6,0.8,2.5c0,1.2-0.3,2.1-1,2.8c-0.6,0.7-1.6,1.1-2.7,1.1c-1.2,0-2.1-0.3-2.7-0.8 c-0.7-0.5-1.1-1.3-1.2-2.1h1.3c0.1,0.5,0.4,1,0.9,1.3c0.4,0.3,1,0.5,1.8,0.5c0.7,0,1.3-0.2,1.7-0.7c0.4-0.5,0.6-1.1,0.6-2 c0-0.8-0.2-1.5-0.6-1.9c-0.4-0.4-1-0.7-1.9-0.7c-0.6,0-1,0.1-1.4,0.4c-0.4,0.3-0.7,0.7-0.9,1.2h-1.3V88.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.1,99.5v-1c0.2-0.2,0.6-0.5,1.2-1c0.5-0.4,0.9-0.8,1.2-1c0.3-0.2,0.6-0.5,1-0.9c0.4-0.4,0.7-0.7,1-1 c0.2-0.3,0.4-0.6,0.7-0.9c0.4-0.7,0.7-1.3,0.7-1.9c0-0.6-0.2-1.1-0.5-1.5c-0.3-0.4-0.9-0.6-1.6-0.6c-0.7,0-1.3,0.2-1.6,0.6 c-0.4,0.4-0.6,1-0.6,1.7h-1.3c0-1.1,0.4-2,1-2.6c0.7-0.6,1.5-0.9,2.5-0.9c1,0,1.9,0.3,2.5,0.9c0.6,0.6,0.9,1.4,0.9,2.4 c0,1.2-0.6,2.5-1.8,3.7c-0.4,0.5-0.8,0.8-1,1c-0.7,0.6-1.4,1.3-2.1,1.9h5.2v1.2H73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4,99.6v-2.5h-5.7v-1l5.3-7.5h1.8V96h1.5v1.2h-1.5v2.5H89.4z M89.4,96v-6l-4.1,6H89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7,89.5c0.3-0.3,0.7-0.6,1.1-0.8c0.5-0.2,1-0.3,1.7-0.3c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.9,0.7,1.2,1.2 c0.5,1,0.8,2.3,0.8,3.9c0,2.1-0.4,3.6-1.1,4.5c-0.6,0.7-1.5,1.1-2.7,1.1c-2.2,0-3.4-1.3-3.8-3.8c-0.1-0.5-0.1-1.1-0.1-1.8 c0-0.7,0-1.2,0.1-1.8c0.1-0.5,0.2-1,0.4-1.5C96.2,90.3,96.4,89.9,96.7,89.5z M101.5,91.1c-0.2-0.4-0.4-0.8-0.8-1 c-0.4-0.2-0.8-0.3-1.3-0.3c-0.5,0-0.9,0.1-1.2,0.2c-0.3,0.2-0.6,0.4-0.7,0.6c-0.2,0.3-0.3,0.6-0.4,1C97.1,92,97,92.4,97,92.7 c0,0.4,0,0.8,0,1.3c0,0.5,0,0.9,0,1.3c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.2,0.7,0.4,1c0.2,0.3,0.4,0.5,0.7,0.6 c0.3,0.2,0.7,0.2,1.1,0.2c0.4,0,0.8-0.1,1.1-0.2c0.3-0.2,0.6-0.4,0.7-0.6c0.2-0.3,0.3-0.6,0.4-1c0.2-0.7,0.2-1.4,0.2-2.2 c0-0.8,0-1.5-0.1-1.9C101.8,92,101.7,91.5,101.5,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8,88.5h7.4v1l-4.4,10.1h-1.5l4.6-9.9h-6.1V88.5z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoleto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boleto.c529bcda32922087e554b2c9b129b761.svg";